import { render, staticRenderFns } from "./filtrateHandleView.vue?vue&type=template&id=210376fc&scoped=true&"
import script from "./filtrateHandleView.vue?vue&type=script&lang=js&"
export * from "./filtrateHandleView.vue?vue&type=script&lang=js&"
import style0 from "./filtrateHandleView.vue?vue&type=style&index=0&id=210376fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210376fc",
  null
  
)

export default component.exports